<template>
    <v-card style="min-height: 80vh; height: 100%; display: flex; flex-direction: column;">
        <v-card-title>
            <div>{{ title }}</div>
        </v-card-title>
        <v-card-text style="flex-grow: 1; display: flex; flex-direction: column;">
            <iframe 
                v-if="eventId"
                :src="src"
                style="flex-grow: 1; border: none;"
            ></iframe>
        </v-card-text>
    </v-card>
</template>

<style>
    .v-window__container {
        height: 100%;
    }
</style>

<script>
import { computed } from "@vue/composition-api";

export default {
    name: 'EventIFrame',
    setup(props, { root }) {
        const eventId = computed(() => root.$route.params.eventId);
        let title = computed(() => {
            switch (eventId.value) {
                // Pasla Conference 2026
                case 'a0711058-fc9a-4bd2-9a22-4886810ab3bb': // Production
                case 'e96ab950-e3d6-4b52-917d-3fcc00614735': // UAT
                    return 'Delegate Approval';
                default:
                    return 'IFrame';
            }
        });
        let src = computed(() => {
            switch (eventId.value) {
                // Pasla Conference 2026
                case 'a0711058-fc9a-4bd2-9a22-4886810ab3bb': // Production
                    return 'https://ff.eventionapp.com/pasla-conference/cms/delegate-approval';
                case 'e96ab950-e3d6-4b52-917d-3fcc00614735': // UAT
                    return 'https://uat.eventionapp.com/pasla-conference/cms/delegate-approval';
                default:
                    return '';
            }
        });

        return {
            eventId,
            title,
            src,
        }
    }
}
</script>
